import React, {useEffect, useState} from "react";
import useCustomTable from "../tables/useCustomTable";
import {Loader, Title} from "../components";
import TableSearch from "../tables/TableSearch";
import Table from "../tables/Table";
import Pagination from "../tables/Pagination";
import {useTranslation} from "react-i18next";
import IabLogo from '../../../assets/images/layout4/iab-logo.png';
import GoogleLogo from '../../../assets/images/layout4/logo_google_g_icon.png'
import EnabledBadge from "../metrics/tables/cells/EnabledCell";
import {VendorModal} from "./VendorModal";
import {Button} from "react-bootstrap";
import Icon from "../Icon";
import {VendorAddModal} from "./VendorAddModal";
import BlockTabs from "../BlockTabs";

export default function Vendors({vendors,
                                  availableVendors,
                                  getAvailableVendors,
                                  params,
                                  updateVendor,
                                  createVendor,
                                  addVendor,
                                  isSuccess,
                                  isLoading,
                                  removeVendor,
                                  isAvailableVendorsLoading}) {
  const { t } = useTranslation()
  const [modalVendor, setModalVendor] = useState()
  const [showModal, setShowModal] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && !isSuccess) }
  const [iabVendors, setIabVendors] = useState([])
  const [googleVendors, setGoogleVendors] = useState([])
  const [customVendors, setCustomVendors] = useState(null)
  const [activeKey, setActiveKey] = useState(null)

  const showVendor = (_vendor) => {
    const {requiredPurposeIds, requiredLegIntPurposeIds, requiredSpecialFeaturesIds, allPurposeIds, allSpecialFeaturesIds, ...vendor} = {..._vendor}
    vendor["purposes"] = []
    vendor["specialFeatures"] = []
    if (allPurposeIds) {
      vendor["purposes"] = allPurposeIds.filter(p => !requiredLegIntPurposeIds?.includes(p)).map(id => {
        return vendors.purposes.find(el => el.id == id && el.type == "purpose")
      }).filter( el => {
        return el !== undefined
      }).map( el => {
        return {...el, removed: !requiredPurposeIds.includes(el.id)}
      })
    }
    requiredLegIntPurposeIds?.forEach(id => {
      vendor["purposes"].push({...vendors.purposes.find(el => el.id == id && el.type == "purpose"), legInt: true})
    })
    if (allSpecialFeaturesIds) {
      vendor["specialFeatures"] = allSpecialFeaturesIds.map(id => {
        return vendors.purposes.find(el => el.id == id && el.type == "special_feature")
      }).map( el => {
        return {...el, removed: !requiredSpecialFeaturesIds.includes(el.id)}
      })
    }
    setModalVendor(vendor)
    setShowModal(true)
  }

  useEffect(() => {
    !showModal && setModalVendor(null)
  }, [showModal])

  useEffect(() => {
    modalVendor && showVendor(vendors.vendors.find(el => el.id == modalVendor.id))
  }, [vendors])

  const vendorFormProps = {
    purposes: vendors.purposes,
    geomediaPurposes: vendors.geomediaPurposes,
    geodataPurposes: vendors.geodataPurposes
  }

  const onCreate = (data) => {
    createVendor({...params, vendor: data}).unwrap().then((data) => {
      setShowAddModal(false)
      showVendor({id: data.vendorId})
    })
  }

  useEffect(() => {
    if (vendors.vendors) {
      setIabVendors(vendors.vendors.filter(vendor => vendor.iabId))
      setGoogleVendors(vendors.vendors.filter(vendor => vendor.googleId))
      setCustomVendors(vendors.vendors.filter(vendor => !vendor.iabId && !vendor.googleId))
    }
  }, [vendors.vendors])

  return <>
    <Title group={false}>
      <Button onClick={() => setShowAddModal(true)}><Icon icon={"plus"}/>{t("cmp.vendors.addVendor")}</Button>
    </Title>

    <BlockTabs title="&nbsp;" defaultActiveKey="iab" activeKey={activeKey}>
      <VendorsTableContainer key="iab"
                             title="iab"
                             loaderProps={loaderProps}
                             data={iabVendors}
                             onRowClick={showVendor}
                             logo={IabLogo}
                             idHeader="ID"
                             idAccessor="iabId"/>
      <VendorsTableContainer key="google"
                             title="google"
                             loaderProps={loaderProps}
                             data={googleVendors}
                             onRowClick={showVendor}
                             logo={GoogleLogo}
                             idHeader="ID"
                             idAccessor="googleId"/>
      <VendorsTableContainer key="custom"
                             title="custom"
                             loaderProps={loaderProps}
                             data={customVendors}
                             onRowClick={showVendor}
                             idHeader="IAB id"
                             idAccessor="iabId"/>
    </BlockTabs>
    <VendorModal
      vendor={modalVendor}
      show={showModal}
      setShow={setShowModal}
      vendorFormProps={vendorFormProps}
      updateVendor={updateVendor}
      params={params}
      removeVendor={removeVendor}
      addVendor={addVendor}
      loaderProps={loaderProps}/>
    <VendorAddModal
      show={showAddModal}
      setShow={setShowAddModal}
      availableVendors={availableVendors}
      getAvailableVendors={getAvailableVendors}
      vendorFormProps={vendorFormProps}
      addVendor={addVendor}
      onCreate={onCreate}
      params={params}
      isAvailableVendorsLoading={isAvailableVendorsLoading}
      setActiveKey={setActiveKey}/>
  </>
}

function VendorsTableContainer({data, onRowClick, logo, idHeader, idAccessor, loaderProps}) {

  const tableOptions = {
    sortable: true,
    paginate: true,
    filterable: true,
    autoWidth: false
  };

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tableFilterProps,
  } = useCustomTable(tableOptions)

  const columns = [{
    Cell: ({row}) => {
      if (logo) {
        return <img src={logo} style={{height: "24px"}}/>
      } else {
        return <></>
      }
    },
    accessor: 'logo',
    maxWidth: 5,
    minWidth: 5,
    disableSortBy: true
  },{
    Header: 'Name',
    accessor: 'name'
  },{
    Header: idHeader,
    accessor: idAccessor
  }, {
    Header: 'Status',
    accessor: 'active',
    Cell: ({row}) => (<EnabledBadge enabled={row.original.active} />),
  }];

  return <Loader {...loaderProps}>
    <TableSearch {...tableSearchProps} style={{float: "right"}}/>
    <Table data={data}
           columns={columns}
           onRowClick={onRowClick}
           {...tableProps} />
    <Pagination {...paginationProps}/>
  </Loader>
}
